export default "__VITE_ASSET__CUU14v6Q__"